import { FunctionComponent, useCallback, useContext } from "react";
import { BetDetailsAction, BetDetailsColor, RoundButtonSize, RoundButtonState } from "@ppb/the-wall-common/types";
import { BetDetails } from "../BetDetails/BetDetails.web";

import LottoSelections from "@ppb/tbd-components-sports-betting/components/LottoCard/view/snowflakes/LottoSelections/LottoSelections.web";

import ConnectedBetControls from "../BetControls";
import { BetControls } from "../BetControls/BetControls.web";
import { ComponentProps } from "./props";
import styles from "./OneLineBet.web.css";
import { RootBetslipContext } from "../RootBetslip/RootBetslipContext";

export const OneLineBet: FunctionComponent<ComponentProps> = ({
  config,
  runnerUrns,
  combinationIds,
  legIds,
  runners,
  subtitle,
  isPlacing,
  selectionTypeIcon,
  hasAvailabilityHints,
  shouldFocusStakeField,
  dispatchRemoveSelectionAction,
}) => {
  const handleOnAction = useCallback(
    () =>
      dispatchRemoveSelectionAction({
        legIds,
        runnerUrns,
      }),
    [dispatchRemoveSelectionAction, legIds, runnerUrns],
  );
  const { isDesktopLayout } = config;
  const { isBetConfirmationStep } = useContext(RootBetslipContext);

  return (
    <article className={styles.single}>
      <BetDetails
        displayAllSubtitleText={isDesktopLayout}
        title={
          !!runners && (
            <LottoSelections runners={runners} size={RoundButtonSize.SMALL} state={RoundButtonState.READ_ONLY} />
          )
        }
        subtitle={subtitle}
        action={!isBetConfirmationStep ? BetDetailsAction.Remove : BetDetailsAction.None}
        color={BetDetailsColor.Teal}
        selectionTypeIcon={selectionTypeIcon}
        onAction={!isBetConfirmationStep ? handleOnAction : undefined}
        isPlacing={isPlacing}
      />
      <ConnectedBetControls
        component={BetControls}
        combinationIds={combinationIds}
        shouldFocusStakeField={shouldFocusStakeField}
        hasAvailabilityHints={hasAvailabilityHints}
      />
    </article>
  );
};
